import { apiClient } from "./apiclient";

// ─── APPOINT ──────────────────────────────────────────────────────────────────
export const createAppoint = (data, token) =>
  apiClient.post("/appoints", data, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getAllAppoints = (token) =>
  apiClient.get("/appoints", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const updateAppoint = (id, data, token) =>
  apiClient.put(`/appoints/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const deleteAppoint = (id, token) =>
  apiClient.delete(`/appoints/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

// ─── BANK ─────────────────────────────────────────────────────────────────────
export const createBank = (data, token) =>
  apiClient.post("/banks", data, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getAllBanks = (token) =>
  apiClient.get("/banks", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const updateBank = (id, data, token) =>
  apiClient.put(`/banks/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const deleteBank = (id, token) =>
  apiClient.delete(`/banks/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

// ─── DEPARTMENT ───────────────────────────────────────────────────────────────
export const createDepartment = (data, token) =>
  apiClient.post("/departments", data, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getAllDepartments = (token) =>
  apiClient.get("/departments", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getDepartmentById = (id, token) =>
  apiClient.get(`/departments/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const updateDepartment = (id, data, token) =>
  apiClient.put(`/departments/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const deleteDepartment = (id, token) =>
  apiClient.delete(`/departments/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

// ─── DESIGNATION ──────────────────────────────────────────────────────────────
export const createDesignation = (data, token) =>
  apiClient.post("/designations", data, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getAllDesignations = (token) =>
  apiClient.get("/designations", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const updateDesignation = (id, data, token) =>
  apiClient.put(`/designations/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const deleteDesignation = (id, token) =>
  apiClient.delete(`/designations/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

// ─── DOCUMENT ─────────────────────────────────────────────────────────────────
export const createDocument = (data, token) =>
  apiClient.post("/documents", data, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getAllDocuments = (token) =>
  apiClient.get("/documents", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const updateDocument = (id, data, token) =>
  apiClient.put(`/documents/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const deleteDocument = (id, token) =>
  apiClient.delete(`/documents/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

// ─── EMPLOYEE ─────────────────────────────────────────────────────────────────
export const submitEmployee = (formData, token) =>
  apiClient.post("/employee/save", formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });

export const getAllEmployees = (token) =>
  apiClient.get("/AllData", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const getEmployeePhoto = (userInfoId, token) =>
  apiClient.get(`/api/photo/${userInfoId}`, {
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const uploadEmpDocument = (formData, token) =>
  apiClient.post("/emp-documents/upload", formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const downloadEmpDocument = (empDocumentId, token) =>
  apiClient.get(`/emp-documents/download/${empDocumentId}`, {
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  // ─── LEAVE CYCLE ────────────────────────────────────────────────────────────
export const createLeaveCycle = (data, token) =>
  apiClient.post("/leave-cycles", data, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getAllLeaveCycles = (token) =>
  apiClient.get("/leave-cycles", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getLeaveCycleById = (id, token) =>
  apiClient.get(`/leave-cycles/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const updateLeaveCycle = (id, data, token) =>
  apiClient.put(`/leave-cycles/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });


  // ─── HOLIDAY TYPE ───────────────────────────────────────────────────────────
export const createHolidayType = (data, token) =>
  apiClient.post("/holiday-types", data, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getHolidayTypes = (token) =>
  apiClient.get("/holiday-types", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const updateHolidayType = (id, data, token) =>
  apiClient.put(`/holiday-types/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });

  // ─── HOLIDAY ENTRY ──────────────────────────────────────────────────────────
export const createHolidayEntry = (holidayTypeId, data, token) =>
  apiClient.post(`/holiday-entries?holidayTypeId=${holidayTypeId}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getAllHolidayEntries = (token) =>
  apiClient.get("/holiday-entries", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const updateHolidayEntry = (id, holidayTypeId, data, token) =>
  apiClient.put(`/holiday-entries/${id}?holidayTypeId=${holidayTypeId}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });

  // ─── LEAVE TYPE ─────────────────────────────────────────────────────────────
export const createLeaveType = (data, token) =>
  apiClient.post("/leave-types", data, { headers: { Authorization: `Bearer ${token}` } });

export const getAllLeaveTypes = (token) =>
  apiClient.get("/leave-types", { headers: { Authorization: `Bearer ${token}` } });

export const updateLeaveType = (id, data, token) =>
  apiClient.put(`/leave-types/${id}`, data, { headers: { Authorization: `Bearer ${token}` } });

// ─── LEAVE TYPE ALLOTMENT ───────────────────────────────────────────────────
export const getAllLeaveTypeAllotments = (token) =>
  apiClient.get("/leave-type-allotments", { headers: { Authorization: `Bearer ${token}` } });

export const saveOrUpdateLeaveTypeAllotment = (data, token) =>
  apiClient.post("/leave-type-allotments/save-or-update", data, { headers: { Authorization: `Bearer ${token}` } });

export const getAllRoles = (token) =>
  apiClient.get("/roles", { headers: { Authorization: `Bearer ${token}` } });

// ─── SHIFT ───────────────────────────────────────────────────────────────
export const createShift = (data, token) =>
  apiClient.post("/shifts", data, { headers: { Authorization: `Bearer ${token}` } });
export const getAllShifts = (token) =>
  apiClient.get("/shifts", { headers: { Authorization: `Bearer ${token}` } });
export const updateShift = (id, data, token) =>
  apiClient.put(`/shifts/${id}`, data, { headers: { Authorization: `Bearer ${token}` } });

// ─── AUTHORITY ───────────────────────────────────────────────────────────
export const createAuthority = (authorizedUserId, data, token) =>
  apiClient.post(`/authorities?authorizedUserId=${authorizedUserId}`, data, { headers: { Authorization: `Bearer ${token}` } });
export const getAuthorities = (token) =>
  apiClient.get("/authorities", { headers: { Authorization: `Bearer ${token}` } });
export const updateAuthority = (id, authorizedUserId, data, token) =>
  apiClient.put(`/authorities/${id}?authorizedUserId=${authorizedUserId}`, data, { headers: { Authorization: `Bearer ${token}` } });

// ─── AUTHORITIES PATH ────────────────────────────────────────────────────
export const createAuthoritiesPath = (authorityId, departmentId, employeeId, data, token) =>
  apiClient.post(
    `/authorities-paths?authorityId=${authorityId}${departmentId ? `&departmentId=${departmentId}` : ""}${employeeId ? `&employeeId=${employeeId}` : ""}`,
    data,
    { headers: { Authorization: `Bearer ${token}` } }
  );
export const getAllAuthoritiesPaths = (token) =>
  apiClient.get("/authorities-paths", { headers: { Authorization: `Bearer ${token}` } });
export const updateAuthoritiesPath = (id, authorityId, departmentId, employeeId, data, token) =>
  apiClient.put(
    `/authorities-paths/${id}?authorityId=${authorityId}${departmentId ? `&departmentId=${departmentId}` : ""}${employeeId ? `&employeeId=${employeeId}` : ""}`,
    data,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  
  // ─── SHIFT ALLOTMENT ─────────────────────────────────────────────────────
export const assignShiftAllotment = (userId, shiftId, token) =>
  apiClient.post(`/shift-allotments?userId=${userId}&shiftId=${shiftId}`, {}, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getAllShiftAllotments = (token) =>
  apiClient.get("/shift-allotments", {
    headers: { Authorization: `Bearer ${token}` },
  });

  // ─── SHIFT CHANGES ───────────────────────────────────────────────────────
export const createShiftChangeRequest = (userId, requestedShiftId, reason, token) =>
  apiClient.post(
    `/shift-change-requests?userId=${userId}&requestedShiftId=${requestedShiftId}`,
    { reason },
    { headers: { Authorization: `Bearer ${token}` } }
  );

export const getAllShiftChangeRequests = (token) =>
  apiClient.get("/shift-change-requests", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const actionShiftChangeRequest = (id, status, token) =>
  apiClient.put(`/shift-change-requests/${id}/action?status=${status}`, {}, {
    headers: { Authorization: `Bearer ${token}` },
  });

  // ─── LEAVE SETUP ─────────────────────────────────────────────────────────
export const createLeaveSetup = (data, token) =>
  apiClient.post("/leave-setups", data, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getAllLeaveSetups = (token) =>
  apiClient.get("/leave-setups", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const updateLeaveSetup = (id, data, token) =>
  apiClient.put(`/leave-setups/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });

  // ─── LEAVE ALLOTMENT ─────────────────────────────────────────────────────
export const saveLeaveAllotments = (data, token) =>
  apiClient.post("/leave-allotments/save", data, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getLeaveAllotmentsByCriteria = (params, token) =>
  apiClient.get("/leave-allotments", {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });

export const updateLeaveAllotment = (id, allocatedDays, token) =>
  apiClient.put(`/leave-allotments/${id}`, { allocatedDays }, {
    headers: { Authorization: `Bearer ${token}` },
  });
  
// ─── LEAVE APPLICATION ───────────────────────────────────────────────────
export const applyLeave = (formData, token) =>
  apiClient.post("/leave-applications/apply", formData, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });

export const editLeave = (id, formData, token) =>
  apiClient.put(`/leave-applications/${id}`, formData, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });

export const getMyLeaves = (token) =>
  apiClient.get("/leave-applications/my", { headers: { Authorization: `Bearer ${token}` } });

export const getMyEmployeeId = (token) =>
  apiClient.get("/user/my-employee-id", { headers: { Authorization: `Bearer ${token}` } });

export const getMyLeaveEmployeeId = (token) =>
  apiClient.get("/leave-applications/my-employee-id", { headers: { Authorization: `Bearer ${token}` } });

export const getAllLeaveApplications = (token) =>
  apiClient.get("/leave-applications/all", { headers: { Authorization: `Bearer ${token}` } });

// returns a blob — used with URL.createObjectURL(...) in a document viewer modal
export const getLeaveDocument = (id, token) =>
  apiClient.get(`/leave-applications/document/${id}`, {
    responseType: "blob",
    headers: { Authorization: `Bearer ${token}` },
  });

export const getHandoverOptions = (token) =>
  apiClient.get("/leave-applications/handover-options", { headers: { Authorization: `Bearer ${token}` } });

export const cancelLeave = (id, token) =>
  apiClient.put(`/leave-applications/${id}/cancel`, {}, { headers: { Authorization: `Bearer ${token}` } });

// ─── LEAVE APPROVAL ───────────────────────────────────────────────────────
export const getPendingLeaves = (token) =>
  apiClient.get("/leave-approvals/pending", { headers: { Authorization: `Bearer ${token}` } });

export const processLeaveApproval = (data, token) =>
  apiClient.put("/leave-approvals", data, { headers: { Authorization: `Bearer ${token}` } });

// ─── COMPENSATORY LEAVE ───────────────────────────────────────────────────
export const createCompensatoryLeave = (formData, token) =>
  apiClient.post("/compensatory-leave", formData, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });

export const updateCompensatoryLeave = (id, formData, token) =>
  apiClient.put(`/compensatory-leave/${id}`, formData, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });

export const getAllCompensatoryLeaves = (token) =>
  apiClient.get("/compensatory-leave", { headers: { Authorization: `Bearer ${token}` } });

// returns a blob — used with URL.createObjectURL(...) in a document viewer modal
export const getCompLeaveDocument = (id, token) =>
  apiClient.get(`/compensatory-leave/document/${id}`, {
    responseType: "blob",
    headers: { Authorization: `Bearer ${token}` },
  });

export const getAllCompensatoryLeavesForApprover = (token) =>
  apiClient.get("/compensatory-leave/pending", { headers: { Authorization: `Bearer ${token}` } });

export const updateCompensatoryLeaveStatus = (id, data, token) =>
  apiClient.patch(`/compensatory-leave/${id}/status`, data, { headers: { Authorization: `Bearer ${token}` } });
